import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil} from 'rxjs/operators';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { EmploymentStatusService } from '@ascschool/services/school/employment-status.service';
import { QualificationService } from '@ascschool/services/category/qualification.service';
import { MajorService } from '@ascschool/services/category/major.service';
import { CapTrucThuocService } from '@ascschool/services/category/cap-truc-thuoc.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { ModulesService } from '@ascschool/services/category/modules.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
@Component({
  selector: 'app-cs-bcttcsgd',
  templateUrl: './cs-bcttcsgd.component.html',
  styleUrls: ['./cs-bcttcsgd.component.scss']
})
export class BcTtCsgdComponent implements OnInit,OnDestroy, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private authQuery: AuthQuery,
    private service: BaocaoService, public utilService: UtilsService, private directlyUnderService: CapTrucThuocService,
    private modesOfEducationService: ModesOfEducationService, private moduleSerVice: ModulesService,
    private typeOfSchoolsService: TypeOfSchoolService, private studyModeService: StudyModeService,
    private mojorServiceService: MajorService, private employmentStatusService: EmploymentStatusService,
    private qualificationService: QualificationService
  ) { }
  get breadcrumbs(): string[] {
    return ['Báo cáo về cơ sở giáo dục'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  // pageOptBtn: BtnOptionExtend[] = [new BtnOptionExtend('Thêm', 'plus', this.AddProvince.bind(this), null, null, Nztheme.OUTLINE, 'text-green-600')]
  $unSubscribe= new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  pageIndex = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading = true;
  Total = 0;
  firstRowOnPage: any;
  dataTable: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  isCollapse = true;
  year = '';
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getDirectlyUnderACFn: (value: any) => Observable<any>; DirectlyUnderSubscription: any; DirectlyUnderControl = new FormControl();
  getModesOfEducationACFn: (value: any) => Observable<any>; ModesOfEducationSubscription: any; ModesOfEducationControl = new FormControl();

  getModuleACFn: (value: any) => Observable<any>; ModuleSubscription: any; ModuleControl = new FormControl();
  getTypeOfEducationACFn: (value: any) => Observable<any>; TypeOfEducationSubscription: any; TypeOfEducationControl = new FormControl();
  getStudyModeACFn: (value: any) => Observable<any>; StudyModeSubscription: any; StudyModeControl = new FormControl();
  getEmploymentStatus: (value: any) => Observable<any>; EmploymentStatusSubscription: any; EmploymentStatusControl = new FormControl();

  getQualification: (value: any) => Observable<any>; QualificationSubscription: any; QualificationControl = new FormControl();
  getMajorACFn: (value: any) => Observable<any>; MajorSubscription: any; MajorControl = new FormControl();

  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.commonFilter.IsDisability = -5;
    this.reload();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.checkCaculateHeight();
    this.commonFilter.year = this.year;
    this.loadDirectlyUnder();
    this.loadModesOfEducation();
    this.loadTypeOfEducation();
    this.loadStudyMode();
    this.commonFilter.year = this.year;
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    this.commonFilter.year = this.year;
    this.service.getRpBcCsgd(this.commonFilter).pipe(takeUntil(this.$unSubscribe)).subscribe((response: any) => {
      const list = response.results ? response.results : [];
      this.Total = response && response.rowCount ? response.rowCount : 0;
      this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
      _this.dataTable = list ? list : [];
      _this.loading = false;
    }, (err: any) => {
      _this.dataTable = [];
      _this.loading = false;
    });
  }

  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }

  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportBcCsgd(this.commonFilter).subscribe((data:any) => {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'BaoCaoThongTinCoSoGiaoDuc.xlsx';
      link.click();
    });
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }

  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => console.log('alt + n'), preventDefault: true
    });
    this.cdRef.detectChanges();
  }

  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }

  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 3000;
    }, 1);
  }

  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.heightPagnagation
    );
  }

  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }

  onResize() {
    this.width = 3000;
    this.checkCaculateHeight(this.isCollapse);
  }

  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }

  resetForm(): void { }
  // tslint:disable-next-line: adjacent-overload-signatures
  loadDirectlyUnder() {
    this.getDirectlyUnderACFn = (value: any) => this.directlyUnderService.getCapTrucThuocSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.DirectlyUnderSubscription) {
      this.DirectlyUnderSubscription = this.DirectlyUnderControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DirectlyUnderId', this.DirectlyUnderControl.value);
      });
    }
  }
  changeDirectlyUnderACFn(control: FormControl) {
    this.DirectlyUnderControl = control;
    if (this.DirectlyUnderControl) {
    }
  }
  loadModesOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getModesOfEducationACFn = (value: any) => this.modesOfEducationService.getSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.DirectlyUnderControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.ModesOfEducationSubscription) {
      this.ModesOfEducationSubscription = this.ModesOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModesOfEducationId', this.ModesOfEducationControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeModesOfEducationACFn(control: FormControl) {
    this.ModesOfEducationControl = control;
    this.loadModule();
  }


  loadModule() {
    this.getModuleACFn = (value: any) => this.moduleSerVice.getSelectPaging({
      TypeOfEducationId: this.valueIfHas(this.ModesOfEducationControl),searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.modulesName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.ModuleSubscription) {
      this.ModuleSubscription = this.ModuleControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModuleId', this.ModuleControl.value);
      });
    }
  }
  changeModule(control: FormControl) {
    this.ModuleControl = control;
  }

  loadTypeOfEducation() {
    this.getTypeOfEducationACFn = (value: any) => this.typeOfSchoolsService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfEducationSubscription) {
      this.TypeOfEducationSubscription = this.TypeOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfEducationId', this.TypeOfEducationControl.value);
      });
    }
  }
  changeTypeOfEducation(control: FormControl) {
    this.TypeOfEducationControl = control;
  }

  loadStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getStudyModeACFn = (value: any) => this.studyModeService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.StudyModeSubscription) {
      this.StudyModeSubscription = this.StudyModeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'StudyModeId', this.StudyModeControl.value);
      });
    }
  }
  changeStudyMode(control: FormControl) {
    this.StudyModeControl = control;
  }


  clear() {
    this.year = '';
    this.DirectlyUnderControl.setValue(null);
    this.ModesOfEducationControl.setValue(null);
    this.ModuleControl.setValue(null);
    this.TypeOfEducationControl.setValue(null);
    this.StudyModeControl.setValue(null);
    this.reload();
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
